<div class="content">
  @if (isRequested() || isUnavailable()) {
    <rs-web-whitelabel-image
      [whitelabelImage]="WhitelabelImage.WAITING"
      [altTag]="WhitelabelImageAltTag.WAITING | translate"
    ></rs-web-whitelabel-image>
  } @else {
    <rs-web-whitelabel-image
      [whitelabelImage]="WhitelabelImage.DOCUMENTS"
      [altTag]="WhitelabelImageAltTag.DOCUMENTS | translate"
    ></rs-web-whitelabel-image>
  }

  @if (isUnavailable()) {
    <h2 class="primary-text">{{ 'documents.unavailable_title_l' | translate }}</h2>
    <p class="primary-text">{{ 'documents.unavailable_desc_l' | translate }}</p>
  } @else {
    <h2 class="primary-text">{{ 'documents.requested_title_l' | translate }}</h2>
    <p class="primary-text">
      @if (isRequested()) {
        {{ 'documents.requested_desc_1_l' | translate }}
      }
      @if (isAlreadyRequested()) {
        {{ 'documents.requested_desc_2_l' | translate }}
      }
    </p>
    <p class="primary-text">{{ 'documents.requested_end_l' | translate }}</p>
  }

  <div class="button-container">
    <button im-button class="primary" (click)="backToOverview.emit()">
      {{ 'documents.requested_back_btn_l' | translate }}
    </button>
  </div>
</div>
